import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-y-0 right-0 flex max-w-full pl-10" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = { class: "mt-5 flex items-center justify-between text-sm" }
const _hoisted_4 = { class: "flex items-center justify-between mt-5" }
const _hoisted_5 = { class: "grid grid-cols-1 gap-2 mt-2" }
const _hoisted_6 = ["data-pace", "aria-pressed", "onClick"]
const _hoisted_7 = { class: "block text-sm font-bold text-gray-900" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-2 mt-2" }
const _hoisted_9 = ["data-budget", "aria-pressed", "onClick"]
const _hoisted_10 = { class: "block text-sm font-bold text-gray-900" }
const _hoisted_11 = { class: "grid grid-cols-2 gap-3 mt-2" }
const _hoisted_12 = {
  key: 0,
  "data-window-error": "",
  class: "text-xs text-red-600 mt-2"
}
const _hoisted_13 = { class: "text-xs text-gray-500 mt-2" }
const _hoisted_14 = { class: "mt-6 flex gap-2" }

import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'
import { computed, inject, reactive, watch } from 'vue'

import NeueButton from '@/components/neue/NeueButton.vue'
import SelectInput from '@/components/neue/SelectInput.vue'

import { BUDGET_CARDS, PACE_CARDS } from './marketingSeries'


export default {
  __name: 'MarketingSettingsDrawer',
  props: { agent: { type: Object, default: null }, busy: { type: Boolean, default: false } },
  emits: ['save'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit

const settings = inject('marketingSettings', { isOpen: { value: false }, close: () => {} })
const isOpen = computed(() => Boolean(settings.isOpen?.value))
const close = () => settings.close()

const HOURS = Array.from({ length: 24 }, (_, h) => ({
  name: `${((h + 11) % 12) + 1} ${h < 12 ? 'am' : 'pm'}`,
  value: h
}))

const form = reactive({ pace: 'full', budget_tier: '$$', send_window_start: 10, send_window_end: 18, is_active: true })
const syncFromAgent = () => {
  const a = props.agent?.attributes || {}
  Object.assign(form, {
    pace: a.pace ?? 'full',
    budget_tier: a.budget_tier ?? '$$',
    send_window_start: a.send_window_start ?? 10,
    send_window_end: a.send_window_end ?? 18,
    is_active: a.is_active ?? true
  })
}
syncFromAgent()

// Re-sync only when the drawer opens, so a refetch or a failed save never wipes unsaved edits.
// A successful save closes the drawer (the shell does that), so the next open picks up the saved agent.
watch(isOpen, open => open && syncFromAgent())

const windowInvalid = computed(() => Number(form.send_window_start) >= Number(form.send_window_end))

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    show: isOpen.value,
    as: "template"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-50",
        onClose: close
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-200",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-150",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
              _createElementVNode("div", {
                class: "fixed inset-0 bg-gray-900/40",
                "aria-hidden": "true"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "transform transition ease-out duration-200",
              "enter-from": "translate-x-full",
              "enter-to": "translate-x-0",
              leave: "transform transition ease-in duration-150",
              "leave-from": "translate-x-0",
              "leave-to": "translate-x-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogPanel), { class: "w-screen max-w-md bg-white shadow-xl p-6 overflow-y-auto" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      _cache[7] || (_cache[7] = _createElementVNode("h2", { class: "text-lg font-bold text-gray-900" }, "Marketing settings", -1)),
                      _createElementVNode("button", {
                        type: "button",
                        "data-close": "",
                        class: "text-gray-500 hover:text-gray-900",
                        onClick: close
                      }, [
                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "sr-only" }, "Close", -1)),
                        _createVNode(_unref(XMarkIcon), {
                          class: "h-5 w-5",
                          "aria-hidden": "true"
                        })
                      ])
                    ]),
                    _createElementVNode("label", _hoisted_3, [
                      _cache[8] || (_cache[8] = _createElementVNode("span", { class: "font-semibold text-gray-900" }, "Agent is on", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((form.is_active) = $event)),
                        "data-active": "",
                        type: "checkbox",
                        class: "h-5 w-5"
                      }, null, 512), [
                        [_vModelCheckbox, form.is_active]
                      ])
                    ]),
                    _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-xs text-gray-500 mt-1" }, " Off stops every send that has not started. Your codes stay live until they expire. ", -1)),
                    _createElementVNode("div", _hoisted_4, [
                      _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "text-sm font-bold text-gray-900" }, "Pace", -1)),
                      _createElementVNode("button", {
                        type: "button",
                        "data-pause": "",
                        class: "text-xs font-semibold text-gray-600 hover:text-gray-900 underline",
                        onClick: _cache[1] || (_cache[1] = $event => (form.pace = 'paused'))
                      }, " Pause ")
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(PACE_CARDS), (c) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: c.value,
                          type: "button",
                          "data-pace": c.value,
                          "aria-pressed": form.pace === c.value,
                          class: _normalizeClass(["text-left rounded-xl border p-3 text-xs text-gray-600", form.pace === c.value ? 'border-gray-900 ring-2 ring-gray-900 ring-inset' : 'border-gray-200']),
                          onClick: $event => (form.pace = c.value)
                        }, [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(c.title), 1),
                          _createTextVNode(" " + _toDisplayString(c.text), 1)
                        ], 10, _hoisted_6))
                      }), 128))
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "text-sm font-bold text-gray-900 mt-5" }, "Monthly budget for offers and sends", -1)),
                    _createElementVNode("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(BUDGET_CARDS), (c) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: c.value,
                          type: "button",
                          "data-budget": c.value,
                          "aria-pressed": form.budget_tier === c.value,
                          class: _normalizeClass(["text-left rounded-xl border p-3 text-xs text-gray-600", 
                  form.budget_tier === c.value ? 'border-gray-900 ring-2 ring-gray-900 ring-inset' : 'border-gray-200'
                ]),
                          onClick: $event => (form.budget_tier = c.value)
                        }, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(c.title), 1),
                          _createTextVNode(" " + _toDisplayString(c.text), 1)
                        ], 10, _hoisted_9))
                      }), 128))
                    ]),
                    _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "text-sm font-bold text-gray-900 mt-5" }, "Send window", -1)),
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(SelectInput, {
                        modelValue: form.send_window_start,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((form.send_window_start) = $event)),
                        name: "Texts from",
                        options: _unref(HOURS)
                      }, null, 8, ["modelValue", "options"]),
                      _createVNode(SelectInput, {
                        modelValue: form.send_window_end,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((form.send_window_end) = $event)),
                        name: "until",
                        options: _unref(HOURS)
                      }, null, 8, ["modelValue", "options"])
                    ]),
                    (windowInvalid.value)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_12, " The window must start before it ends. "))
                      : _createCommentVNode("", true),
                    _createElementVNode("p", _hoisted_13, " Your time zone. At most " + _toDisplayString(__props.agent?.attributes?.daily_send_cap || 250) + " texts a day. ", 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(NeueButton, {
                        "data-save": "",
                        loading: __props.busy,
                        disabled: __props.busy || windowInvalid.value,
                        onClick: _cache[4] || (_cache[4] = $event => (emit('save', { ...form })))
                      }, {
                        default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                          _createTextVNode(" Save ", -1)
                        ]))]),
                        _: 1
                      }, 8, ["loading", "disabled"]),
                      _createVNode(NeueButton, {
                        type: "secondary",
                        disabled: __props.busy,
                        onClick: close
                      }, {
                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                          _createTextVNode("Cancel", -1)
                        ]))]),
                        _: 1
                      }, 8, ["disabled"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["show"]))
}
}

}